import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import TimeAgo from '../TimeAgo';

function renderClientRow(website, key) {
  return (
    <tr key={key}>
      <td>
        <a href={website.url} target="_blank" rel="noopener noreferrer">
          {website.company.name}
        </a>
      </td>
      <td>
        <TimeAgo date={website.dateAdded} />
      </td>
    </tr>
  );
}

const WebsiteTable = ({ title, websites }) => (
  <Table>
    <thead>
      <tr>
        <th colSpan={2}>
          {title}
        </th>
      </tr>
    </thead>
    <tbody>
      {websites.map(renderClientRow)}
    </tbody>
  </Table>
);
WebsiteTable.propTypes = {
  title: PropTypes.node.isRequired,
  websites: PropTypes.arrayOf(PropTypes.shape({
    companyId: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
    company: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }),
    url: PropTypes.string.isRequired,
    dateAdded: PropTypes.string.isRequired,
  })).isRequired,
};

export default WebsiteTable;
